import "./Signin.scss";
import React, { useEffect, useState } from "react";
import {
  IonButton,
  IonContent,
  IonInput,
  IonItem,
  IonList,
  IonLoading,
  IonPage,
  IonText,
  isPlatform,
  useIonViewWillLeave,
} from "@ionic/react";
import { Plugins } from "@capacitor/core";

import clsx from "clsx";
import { getUserByEmail, loginIdentity } from "../../api/user";
// import * as jwtDecode from "jwt-decode";
import { useTracked } from "../../state";
import { ShowToastErrorMessage } from "../../utils/helpers/ToastMessage";
import CheckEmailModal from "../../components/CheckEmailModal";
import LandingHeader from "../../components/LandingHeader";
import LandingFooter from "../../components/LandingFooter";
import { useHistory } from "react-router-dom";

const { Keyboard } = Plugins;

const Signin: React.FC = () => {
  const history = useHistory();
  const [state, dispatch] = useTracked();
  const [alias, setAlias] = useState<string>("");
  const [aliasError, setAliasError] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [isOpenCheckEmail, setIsOpenCheckEmail] = useState<boolean>(false);
  const [isOpenKeyboard, setIsOpenKeyboard] = useState<boolean>(false);

  useEffect(() => {
    if (isPlatform("cordova")) {
      Keyboard.addListener("keyboardDidShow", () => {
        setIsOpenKeyboard(true);
      });
      Keyboard.addListener("keyboardWillHide", () => {
        setIsOpenKeyboard(false);
      });
    }

    return () => {
      setIsOpenCheckEmail(false);
    };
  }, []);

  useEffect(() => {
    if (!state.hasOnboarding) {
      history.replace("/onboarding");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.hasOnboarding]);

  useIonViewWillLeave(() => {
    setIsOpenCheckEmail(false);
  });

  useEffect(() => {
    if (state.token && state.user) {
      setIsOpenCheckEmail(false);
    }
  }, [state.token, state.user]);

  const handleChange = (e: any) => {
    const { value } = e.target;
    setAliasError("");
    setAlias(value);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const userResp = await getUserByEmail(alias);
      let resp: any = null;

      if (userResp?.data) {
        resp = await loginIdentity(alias);
      } else {
        ShowToastErrorMessage("Invalid login");
        setLoading(false);
        return;
      }

      if (resp && resp.status === 200) {
        if (resp.identity) {
          localStorage.setItem("isFromRecoverFlow", JSON.stringify(true));
          dispatch({ identity: resp.identity, type: "setIdentity" });
          setIsOpenCheckEmail(true);
        } else {
          ShowToastErrorMessage("Invalid login");
        }
      } else {
        if (resp?.message) {
          setAliasError(resp?.message);
        } else {
          ShowToastErrorMessage("Login failed");
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      ShowToastErrorMessage("Login failed");
    }
  };

  return (
    <IonPage className={clsx("signin-page", { "on-keyboard": isOpenKeyboard })}>
      <IonContent>
        <div className="signin-page-container">
          <LandingHeader />
          <div className="content-body">
            <IonText className="sub-title">Enter your details</IonText>

            <IonList lines="none" mode="ios">
              <IonItem
                lines="none"
                detail={false}
                className="item-label-stacked"
              >
                <IonInput
                  name="alias"
                  type="text"
                  inputMode="email"
                  placeholder="Enter email here"
                  value={alias}
                  maxlength={144}
                  onIonChange={handleChange}
                  className={clsx({ "has-error": !!aliasError })}
                />
                {aliasError && <div className="error-text">{aliasError}</div>}
              </IonItem>
            </IonList>

            <IonButton
              color={!alias ? "light" : "danger"}
              expand="full"
              shape="round"
              className={clsx("signin-btn", {
                disabled: !alias ? true : false,
              })}
              disabled={!alias}
              onClick={() => {
                handleSubmit();
              }}
            >
              Continue
            </IonButton>

            <div className="btn-content">
              <IonText className="or-identity-label">Or</IonText>
            </div>

            <IonText className="create-identity-label">
              Create your identity
            </IonText>

            <IonButton
              expand="full"
              fill="outline"
              shape="round"
              className="create-identity-btn"
              routerDirection="none"
              routerLink="/register"
            >
              Create Identity
            </IonButton>
          </div>
        </div>

        <IonLoading isOpen={loading} />
      </IonContent>
      <LandingFooter />
      <CheckEmailModal isOpen={isOpenCheckEmail} />
    </IonPage>
  );
};

export default Signin;
